import { Link } from "react-router-dom";
import { Facebook, Instagram, Mail, MapPin, Phone, Star } from "lucide-react";
import { SITE, waLink } from "@/config/site";

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-white/[0.06] bg-[#070708] font-outfit">
    <div className="container-lux py-20 grid grid-cols-1 md:grid-cols-3 gap-14">
      <div>
        <img src="/logo.png" alt="MetalMuse logo" className="w-12 h-12 rounded-full ring-1 ring-white/15 mb-5" />
        <p className="font-tech text-xl font-semibold uppercase tracking-[0.12em] text-silver-gradient">{SITE.name}</p>
        <p className="text-[10px] uppercase tracking-[0.35em] text-[#A1A1AA] mt-2">Art. Made to Last.</p>
        <p className="text-sm text-[#A1A1AA] mt-6 leading-relaxed">
          Premium sublimation metal art panels — anime, memories, pop culture and custom pieces, crafted in {SITE.region}.
        </p>
        <div className="flex gap-4 mt-6">
          <a href={SITE.facebookUrl} target="_blank" rel="noopener noreferrer" data-testid="footer-facebook" aria-label="Facebook" className="text-[#A1A1AA] hover:text-cyan-300 transition-colors duration-300">
            <Facebook size={20} />
          </a>
          <a href={SITE.instagramUrl} target="_blank" rel="noopener noreferrer" data-testid="footer-instagram" aria-label="Instagram" className="text-[#A1A1AA] hover:text-cyan-300 transition-colors duration-300">
            <Instagram size={20} />
          </a>
        </div>
        {SITE.googleReviewUrl && (
          <a
            href={SITE.googleReviewUrl}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="google-reviews-badge"
            className="mt-7 inline-flex items-center gap-2.5 border border-white/10 rounded-full px-4 py-2.5 hover:border-cyan-400/40 transition-colors duration-300"
          >
            <Star size={14} className="text-cyan-300" fill="currentColor" />
            <span className="text-xs text-white/85 font-medium">Find us on Google</span>
            <span className="text-[10px] text-[#A1A1AA]">Be our first reviewer</span>
          </a>
        )}
      </div>
      <div>
        <p className="uppercase tracking-[0.3em] text-[10px] font-semibold text-cyan-300/80 mb-6">Explore</p>
        <div className="flex flex-col gap-3.5 text-sm">
          {[["/", "Home"], ["/shop", "Shop"], ["/order", "Custom Art"], ["/gallery", "Gallery"], ["/about", "About"], ["/faq", "FAQ"], ["/contact", "Contact"]].map(([to, label]) => (
            <Link key={label} to={to} data-testid={`footer-link-${label.toLowerCase().replace(/\s+/g, "-")}`} className="text-[#A1A1AA] hover:text-white transition-colors duration-300">
              {label}
            </Link>
          ))}
        </div>
      </div>
      <div>
        <p className="uppercase tracking-[0.3em] text-[10px] font-semibold text-cyan-300/80 mb-6">Get in Touch</p>
        <div className="flex flex-col gap-4 text-sm text-[#A1A1AA]">
          <a href={`mailto:${SITE.email}`} data-testid="footer-email" className="flex items-center gap-3 hover:text-white transition-colors duration-300">
            <Mail size={16} className="text-cyan-300/80" /> {SITE.email}
          </a>
          <a href={waLink("Hi MetalMuse! I'd like to ask about a metal print.")} target="_blank" rel="noopener noreferrer" data-testid="footer-phone" className="flex items-center gap-3 hover:text-white transition-colors duration-300">
            <Phone size={16} className="text-cyan-300/80" /> {SITE.phoneDisplay}
          </a>
          <p className="flex items-center gap-3">
            <MapPin size={16} className="text-cyan-300/80" /> {SITE.region}
          </p>
        </div>
      </div>
    </div>
    <div className="border-t border-white/[0.04] py-6">
      <p className="container-lux text-xs text-[#A1A1AA]/70">
        © {new Date().getFullYear()} {SITE.name}. All rights reserved. Artwork shown is sample imagery.
      </p>
    </div>
  </footer>
);
